import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			ads: {},
			adPosConfig: {
				homeRecommand: [1, 2, 3],
				homeRecommandPC: [3],
			},
			adsensConfig: {
				scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4688525518274277',
				home_0: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				home_1: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				home_insert: {
					mobile: [
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '7515363638',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '3576118620',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '7853288877',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
					],
					pc: [
						{
							style: 'display:block',
							'data-ad-client': 'ca-pub-9524345982013195',
							'data-ad-slot': '7515363638',
							'data-ad-format': 'auto',
							'data-full-width-responsive': 'true',
							class: 'adsbygoogle',
						},
					],
				},
				all: [
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '1870648774',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '1870648774',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
					{
						class: 'adsbygoogle',
						style: 'display:block',
						'data-ad-client': 'ca-pub-4688525518274277',
						'data-ad-slot': '1870648774',
						'data-ad-format': 'auto',
						'data-full-width-responsive': 'true',
					},
				],
				detail_1: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				detail_2: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
				detail_3: {
					class: 'adsbygoogle',
					style: 'display:block',
					'data-ad-client': 'ca-pub-4688525518274277',
					'data-ad-slot': '1870648774',
					'data-ad-format': 'auto',
					'data-full-width-responsive': 'true',
				},
			},
			domainConfig: {
				siteName: 'Speed Thrills',
				siteIcon: '/icon/17.svg',
				siteThemeColor: 2,
				componentOrder: [
					{
						type: 'CarRangRank',
						id: 'rangrank',
					},
					{ type: 'Ad', id: 'ad_2', showPC: false },
					{
						type: 'CarNewRelease',
						id: 'newrelease',
					},
					{
						type: 'CarPopular',
						id: 'popular',
					},
					{ type: 'Ad', id: 'ad_1', showPC: true },
					{
						type: 'CarRecommend',
						id: 'recommend',
					},
					{ type: 'Ad', id: 'ad_3', showPC: false },
					{
						type: 'CarType',
						id: 'type',
					},
					{
						type: 'CarBrands',
						id: 'brands',
					},
				],
				IAMEMAIL: 'contact@carspeed.online',
				IAmURL: 'carspeed.online',
				ABOUTUS: 'Dedicated to the thrill of speed we offer expert reviews and performance tips for speed enthusiasts.',
				galleryImages: '/background/car/galleryImages/3/gallery.png',
				meta: {
					title: '| Ultimate Car Speed Reviews',
					des: 'Experience the thrill of speed with our in-depth car performance evaluations.',
				},
				gallery: {
					title: 'Feel the Need for Speed.',
					content: "Dive into the world of high-octane thrills with expert reviews and tips to maximize your car's performance.",
				},
				firebase: {
					apiKey: 'AIzaSyBCmt3sEU3L1Nu2L8h_cGFWHkrubEzmEQE',
					authDomain: 'web-pub-1181-1.firebaseapp.com',
					projectId: 'web-pub-1181-1',
					storageBucket: 'web-pub-1181-1.firebasestorage.app',
					messagingSenderId: '868494016643',
					appId: '1:868494016643:web:ba0a1f83f21d230889dbb6',
					measurementId: 'G-Q5VSDQTJFE',
				},
				ads: 'google.com, pub-1907067205971181, DIRECT, f08c47fec0942fa0',
				adsense: {
					scriptUrl: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1907067205971181',
				},
				themeFilters: {},
				webIndex: 2,
			},
			categories: [],
			recommendList: [],
			// 品牌列表数据
			brandList: [{ label: 'All', value: 'all' }],
			// 品牌列表是否已加载
			brandListLoaded: false,
			// 车辆列表页状态
			carListState: {
				// 是否从详情页返回
				fromDetail: false,
				// 当前页码
				currentPage: 1,
				// 筛选条件
				filters: {
					purpose: 'all',
					brand: 'all',
					type: 'all',
					price: 'all',
					fuel: 'all',
				},
				// 最近访问页面路径
				lastVisitedPage: '',
				// 查询参数
				queryParams: {},
			},
			// 原始推荐车辆数据（API返回的未处理数据）
			originalTopCars: [],
			// 推荐车辆数据是否已加载
			topCarsLoaded: false,
			// 上次数据加载时间戳
			topCarsLoadTime: null,
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
			// 设置品牌列表
			SET_BRAND_LIST(state, brandList) {
				state.brandList = brandList
			},
			// 设置品牌列表加载状态
			SET_BRAND_LIST_LOADED(state, loaded) {
				state.brandListLoaded = loaded
			},
			// 设置列表页状态
			SET_CAR_LIST_STATE(state, { fromDetail, currentPage, filters, lastVisitedPage, queryParams }) {
				state.carListState = {
					fromDetail: fromDetail !== undefined ? fromDetail : state.carListState.fromDetail,
					currentPage: currentPage || state.carListState.currentPage,
					filters: filters || state.carListState.filters,
					lastVisitedPage: lastVisitedPage || state.carListState.lastVisitedPage,
					queryParams: queryParams || state.carListState.queryParams,
				}
			},
			// 设置来源页面是否为详情页
			SET_FROM_DETAIL(state, fromDetail) {
				state.carListState.fromDetail = fromDetail
			},
			// 设置当前页码
			SET_CURRENT_PAGE(state, page) {
				state.carListState.currentPage = page
			},
			// 设置筛选条件
			SET_FILTERS(state, filters) {
				state.carListState.filters = { ...state.carListState.filters, ...filters }
			},
			// 设置最近访问页面
			SET_LAST_VISITED_PAGE(state, page) {
				state.carListState.lastVisitedPage = page
			},
			// 设置查询参数
			SET_QUERY_PARAMS(state, params) {
				state.carListState.queryParams = params
			},
			// 重置列表页状态
			RESET_CAR_LIST_STATE(state) {
				state.carListState = {
					fromDetail: false,
					currentPage: 1,
					filters: {
						purpose: 'all',
						brand: 'all',
						type: 'all',
						price: 'all',
						fuel: 'all',
					},
					lastVisitedPage: '',
					queryParams: {},
				}
			},
			// 设置原始推荐车辆数据
			SET_ORIGINAL_TOP_CARS(state, data) {
				state.originalTopCars = data
				state.topCarsLoaded = true
				state.topCarsLoadTime = Date.now()
			},
			// 重置推荐车辆加载状态
			RESET_TOP_CARS_LOADED(state) {
				state.topCarsLoaded = false
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			// 获取品牌列表
			brandList: (state) => state.brandList,
			// 品牌列表是否已加载
			brandListLoaded: (state) => state.brandListLoaded,
			// 车辆列表状态
			carListState: (state) => state.carListState,
			isFromDetail: (state) => state.carListState.fromDetail,
			currentPage: (state) => state.carListState.currentPage,
			filters: (state) => state.carListState.filters,
			lastVisitedPage: (state) => state.carListState.lastVisitedPage,
			queryParams: (state) => state.carListState.queryParams,
			// 获取原始推荐车辆数据
			originalTopCars: (state) => state.originalTopCars,
			// 推荐车辆数据是否已加载
			topCarsLoaded: (state) => state.topCarsLoaded,
			// 获取上次数据加载时间戳
			topCarsLoadTime: (state) => state.topCarsLoadTime,
		},
	})
}
